import { render, staticRenderFns } from "./request-items.vue?vue&type=template&id=6825434c&"
import script from "./request-items.vue?vue&type=script&lang=js&"
export * from "./request-items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports